{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "Check-out",
      "checkInDeprecated": "Check-in (Không còn hỗ trợ)",
      "checkIn": "Check-in",
      "receivedLoadInspection": "Kiểm tra hàng nhận",
      "shippedLoadVerification": "Xác minh hàng xuất",
      "appointmentsPerLoadType": "Cuộc hẹn theo loại hàng",
      "assetDetails": "Chi tiết tài sản",
      "yardManagementSystem": "Hệ thống quản lý bãi",
      "smartGateIntegration": "Tích hợp SmartGate",
      "gateManagement": "Quản lý cổng",
      "idValidation": "Xác minh danh tính",
      "appointmentCompleted": "Cuộc hẹn đã hoàn tất"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>Số điện thoại</strong> và <strong>công ty vận chuyển</strong> sẽ được thu thập theo mặc định"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "Thu thập thông tin check-in từ tài xế cho cả lượt đến có kế hoạch và không có kế hoạch.",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "Thu thập dữ liệu check-out sau khi cuộc hẹn hoàn tất.",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "Thu thập thông tin tài xế khi họ tự check-in cho cuộc hẹn đã lên kế hoạch. Tính năng này là tiện ích bổ sung tùy chọn cho giải pháp Quản lý cổng của chúng tôi.",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "Ghi nhận hư hỏng, sai lệch hoặc các vấn đề khác liên quan đến hàng nhận.",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "Ghi nhận tình trạng nguyên vẹn của hàng và các biện pháp an ninh khác liên quan đến hàng xuất.",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "Thu thập thông tin riêng theo loại hàng trong khi đặt lịch hẹn.",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "Lưu trữ và theo dõi thông tin rơ-moóc và container khi chúng đến bãi của bạn.",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "Bật mô-đun YMS cho kho hàng này, đồng thời bật các trường lượt ghé của tài sản cho ứng dụng quản lý cổng.",
      "enableTheSmartGateModuleForThisWarehouse": "Bật mô-đun SmartGate cho kho hàng này.",
      "enableTheIdValidationForThisWarehouse": "Bật mô-đun Xác minh danh tính cho kho hàng này.",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "Bật mô-đun Quản lý cổng cho kho hàng này, bao gồm check-in",
      "reviewAndManageAppointmentDataAfterCompletion": "Xem xét và quản lý dữ liệu cuộc hẹn sau khi hoàn tất."
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Tìm hiểu cách hoạt động</a> hoặc liên hệ với chúng tôi để <a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">yêu cầu dùng thử.</a>.",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Tìm hiểu cách hoạt động.</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "Tài xế sẽ thấy biểu mẫu này khi tự check-in.",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "Tất cả các trường trên biểu mẫu này sẽ <strong>khả dụng và hiển thị</strong> trong khi đặt lịch hẹn."
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "Tài xế sẽ không thấy biểu mẫu này khi tự check-in.",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "Tất cả các trường trên biểu mẫu này sẽ <strong>không khả dụng</strong> trong khi đặt lịch hẹn.<br />Bạn có thể bật lại biểu mẫu này bất cứ lúc nào."
    },
    "labels": {
      "updateClaimsSupport": "Cập nhật hỗ trợ khiếu nại",
      "selectAClaimsSupportToUpdate": "Chọn một hỗ trợ khiếu nại để cập nhật",
      "damageType": "Loại hư hỏng",
      "damageDescription": "Mô tả hư hỏng",
      "damagePhotos": "Ảnh hư hỏng",
      "discrepancyType": "Loại sai lệch",
      "discrepancyDescription": "Mô tả sai lệch",
      "discrepancyPhotos": "Ảnh sai lệch",
      "loadSecurityChecked": "Đã kiểm tra an ninh hàng hóa",
      "loadSecurityDescription": "Mô tả an ninh hàng hóa",
      "loadIntegrityPhotos": "Ảnh tình trạng hàng hóa",
      "sealIntegrityPhotos": "Ảnh tình trạng niêm phong"
    }
  }
}
